module.exports = __webpack_public_path__ + "img/icon-fund-white.ee66cafd.svg";